import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Trailer, TrailerService } from 'src/app/services/app/trailer.service';
import { Yard } from 'src/app/services/app/yard.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'spot-view',
  templateUrl: './spot-view.component.html',
  styleUrls: ['./spot-view.component.css'],
})
export class SpotViewComponent implements OnInit {
  // inputed yard value.
  @Input() selectedYard: Yard;
  @Input() availableTrailers: Trailer[];
  selectedTrailer: Trailer;
  updatedTrailer: Trailer;
  @Output() targetTrailer: EventEmitter<Trailer> = new EventEmitter<Trailer>();
  @Output() updateTrailer: EventEmitter<Trailer> = new EventEmitter<Trailer>();
  @Output() checkout: EventEmitter<Yard> = new EventEmitter<Yard>();
  
  trailerStatus: string[] = [];
  //default to view mode
  viewMode: string;
  viewModeOptions: string[] = ['view', 'add','edit'];
  inViewMode: boolean = true;
  confirmDeleteMode: boolean = false;
  /*
  All of the business logic is managed in the parent componet. This component
  is used to relay info back to the parent compoent so that is can be dealt
   with accordingly.
  */
  constructor(private utilsService: UtilitieService, private trailerService: TrailerService) {
    this.updatedTrailer = null;
  }

  enterDeleteMode() {
    this.confirmDeleteMode = this.confirmDeleteMode == true ? false : true;
  }
  onTrailerSelectionChange(event: any) {
    this.updatedTrailer = event.value;
    // trailer location is defaulted to lost as lost trailers 
    // are the only ones that can be added
    this.updatedTrailer.location = this.selectedYard.location;
  }
  assignTrailer() {
    this.targetTrailer.emit(this.updatedTrailer);
    this.enterViewMode();
  }
  
  checkOutTrailer() {
    this.checkout.emit(this.selectedYard);
    this.enterDeleteMode();
    this.enterEditMode();
    /**
     * removing trailer from database then clearing out the trailer info and
     * finally updating the yard in the database.
     */
    /*
    this.selectedYard.carrier = '';
    this.selectedYard.trailer_number = '';
    this.selectedYard.trailer_status = '';
    this.yardService.updateYard(this.selectedYard);
    */
  }
  enterAddMode(){
    this.viewMode = this.viewModeOptions[1];
  }
  enterEditMode() {
    this.updatedTrailer = this.selectedYard.trailer;
    this.viewMode = this.viewModeOptions[2];
  }
  exitEditMode(){
    this.updatedTrailer = this.selectedYard.trailer;
    this.viewMode = this.viewModeOptions[0];
  }
  enterViewMode(){
    this.viewMode = this.viewModeOptions[0];
    this.selectedTrailer = null;
  }
  updateTrailerData() {
    this.updatedTrailer.location = this.selectedYard.location;
    this.utilsService.openConfirmationDialog('Trailer update','Are you sure you want to update this trailer?')
    .then(result =>{
      if(result){ 
        this.updateTrailer.emit(this.updatedTrailer);
       this.viewMode = this.viewModeOptions[0];
      }
    })
   
    //this.yardService.addYardSpot(data);
    
  }
  ngOnInit(): void {
    this.viewMode = this.viewModeOptions[0];
    this.trailerStatus = this.trailerService.getCheckinTrailerStatus();
  }
}
